<div class="search-facets-container">
    <!--<div class="search-facet-item" *ngFor="let facet of facets">
    <div class="search-facet-item-header" (click)="facet.expanded = !facet.expanded">
      <span>{{facet?.displayName}}</span>
      <div class="search-facet-item-header-images" [ngClass]="facet.expanded?'':'collapsed'">
        <i class="fa fa-fw fa-chevron-down"></i>
        <i class="fa fa-fw fa-chevron-left"></i>
      </div>
    </div>
    <div class="search-facet-item-entries-container" [ngbCollapse]="!facet.expanded">
      <div class="search-facet-item-entries-item" *ngFor="let entry of facet.entries">
        <div class="search-facet-item-entries-item-cb"><input type="checkbox" id="sfi_chk_{{facet.id}}_{{entry.html}}" (change)="facetCheck($event)" [checked]="entry.checked" /></div>
        <div class="search-facet-item-entries-item-title">{{entry.html}}</div>
        <div class="search-facet-item-entries-item-count">({{entry.count}})</div>
      </div>
    </div>
  </div>-->

  <isg-accordion size="small">
    <isg-panel title="{{facet?.displayName}}" *ngFor="let facet of facets">
      <ng-template isgPanelContent>
        <div class="search-facet-item-entries-item" *ngFor="let entry of facet.entries">
          <div class="search-facet-item-entries-item-cb"><input type="checkbox" id="sfi_chk_{{facet.id}}_{{entry.html}}" (change)="facetCheck($event)" [checked]="entry.checked" /></div>
          <div class="search-facet-item-entries-item-title" *ngIf="facet?.id != 'mes:lang'">{{entry.html | removeCharacter}}</div>
          <div class="search-facet-item-entries-item-title" *ngIf="facet?.id == 'mes:lang'">{{entry.description | removeCharacter}}</div>
          <!--<div class="search-facet-item-entries-item-count">({{entry.count}})</div>-->
        </div>
      </ng-template>
    </isg-panel>
  </isg-accordion>

</div>
